import { registerPlugin } from '@capacitor/core';
const rtsp_view = registerPlugin('rtsp_view', {
    web: () => import('./web').then(m => new m.rtsp_viewWeb()),
});
/**
 * @deprecated 此插件已废弃，请使用rtsp_view插件，它现在包含了所有JNI功能
 */
const rtsp_jni = registerPlugin('rtsp_jni', {
    web: () => import('./web').then(m => new m.rtsp_jniWeb()),
});
export * from './definitions';
export { rtsp_view, rtsp_jni };
//# sourceMappingURL=index.js.map